// extracted by mini-css-extract-plugin
export default {"svg":"YearsAnimation_svg__QrW52"};